import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface CuocDieuTraApi {
  name: string;
  api_token: string;
}

export interface CuocDieuTraApiInfo {
  errors: unknown;
  listCuocDieuTraApi: CuocDieuTraApi;
  isAuthenticated: boolean;
}

@Module
export default class CuocDieuTraApiModule
  extends VuexModule
  implements CuocDieuTraApiInfo
{
  errors = {};
  listCuocDieuTraApi = {} as CuocDieuTraApi;
  cuocDieuTraApiDetail = {};
  isAuthenticated = !!JwtService.getToken();

  get getListCuocDieuTraApi() {
    return this.listCuocDieuTraApi;
  }

  get getCuocDieuTraApiDetail() {
    return this.cuocDieuTraApiDetail;
  }

  @Mutation
  [Mutations.CUOC_DIEU_TRA_API_LIST_DATA](listCuocDieuTraApi) {
    this.listCuocDieuTraApi = listCuocDieuTraApi;
  }

  @Mutation
  [Mutations.CUOC_DIEU_TRA_API_DETAIL_DATA](cuocDieuTraApiDetail) {
    this.cuocDieuTraApiDetail = cuocDieuTraApiDetail;
  }

  @Action
  [Actions.CUOC_DIEU_TRA_API_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      const cuocdieutraId = payload.searchParams.cuocdieutraApi;
      delete payload.cuocdieutraId;
      return ApiService.post(`/cuocdieutra_api/${cuocdieutraId}`, payload)
        .then((data) => {
          this.context.commit(Mutations.CUOC_DIEU_TRA_API_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.CUOC_DIEU_TRA_API_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/cuocdieutra_api",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.CUOC_DIEU_TRA_API_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.CUOC_DIEU_TRA_API_CREATE](payload) {
    console.log("payload is:", payload);
    if (JwtService.getToken()) {
      ApiService.setHeader();
      const cuocdieutraId = payload.get("cuocdieutraApi");
      payload.delete("cuocdieutraApi");
      return ApiService.post(
        `/cuocdieutra_api/${cuocdieutraId}/upsert`,
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.CUOC_DIEU_TRA_API_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.CUOC_DIEU_TRA_API_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      const cuocdieutraId = payload.get("cuocdieutraApi");
      payload.delete("cuocdieutraApi");
      return ApiService.getDataDetail(
        `/cuocdieutra_api/${cuocdieutraId}`,
        "upsert",
        id,
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.CUOC_DIEU_TRA_API_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
